import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        templateI18n: '<',
        cancel: '&'
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.cancel()"></button>
            <h2>{{ 'template.E-mail preview' | translate }}</h2>
        </div>
        <div class="modal-body">
            <div class="alert alert-plain">
                <p>{{ 'template.templateTagsText' | translate }}</p>
            </div>
            <h3>{{ vm.msgSubject }}</h3>
            <div ng-bind-html="vm.msgBody"></div>
        </div>
        <div class="modal-footer" >
            <ul class="actions01">
                <li class="primary"><button class="btn main" type="button" ng-click="vm.cancel()">{{ 'general.Ok' | translate }}</button></li>
            </ul>
        </div>
    `
})
export default class {
    constructor ($state, $location, $translate, NOTIFICATION_TEMPLATE_ENUM, TokenService) {
        this.$translate = $translate;
        this.$state = $state;
        this.$location = $location;
        this.NOTIFICATION_TEMPLATE_ENUM = NOTIFICATION_TEMPLATE_ENUM;
        this.TokenService = TokenService;
    }

    $onInit () {
        this.translationMap = {};

        // In case company and active languages are different reload NOTIFICATION_TEMPLATE_ENUM with company translations and then switch back
        if (this.TokenService.getCompanyLanguage() !== this.TokenService.getActiveLanguage()) {
            this.$translate.use(this.TokenService.getCompanyLanguage(true)).then(() => {
                this.initTemplateTranslations();
                this.msgSubject = this.parseVariables(this.templateI18n.msgSubject);
                this.msgBody = this.parseVariables(this.templateI18n.msgBody);

                this.$translate.use(this.TokenService.getActiveLanguage(true));
            });
        }
        else {
            this.initTemplateTranslations();
            this.msgSubject = this.parseVariables(this.templateI18n.msgSubject);
            this.msgBody = this.parseVariables(this.templateI18n.msgBody);
        }
    }

    /**
     * Gather all translations according to required ones in templateI18n.variablesJson
     */
    initTemplateTranslations () {
        const variablesToReplace = Object.getOwnPropertyNames(this.templateI18n.variablesJson);

        variablesToReplace.forEach((variable) => {
            let translation = this.NOTIFICATION_TEMPLATE_ENUM.TRANSLATIONS[variable];

            const specialVariablesToReplace = ['company', 'trainingPortalUrl', 'activationLink', 'coursyUrl', 'externalWpBaseUrl', 'courseDetailViewUrl', 'expirationDate'];
            if (specialVariablesToReplace.includes(variable)) {
                if (variable === 'company') {
                    translation = this.TokenService.getCompanyName();
                }
                else if (variable === 'trainingPortalUrl'
                || variable === 'activationLink'
                || variable === 'externalWpBaseUrl'
                || variable === 'courseDetailViewUrl') {
                    translation = this.TokenService.getCompanyTrainingPortalUrl();
                }
                else if (variable === 'coursyUrl') {
                    translation = this.constructCoursyUrl();
                }
                else if (variable === 'expirationDate') {
                    translation = this.formatDate(new Date());
                }
            }
            this.translationMap[variable] = translation;
        });
    }

    formatDate (d) {
        const pad = (n) => String(n).padStart(2, '0');
        const day = pad(d.getDate());
        const month = pad(d.getMonth() + 1);
        const year = d.getFullYear();
        return `${day}.${month}.${year}`;
    }

    parseVariables (stringContent) {
        if (!stringContent) {
            return '';
        }

        let result = angular.copy(stringContent);
        for (const key in this.translationMap) {
            if (this.translationMap.hasOwnProperty(key)) {
                // replace all matches like {{?<variable>?}} with translations gathered into translationMap
                const regexCondition = new RegExp(`\\{\\{\\s*${key}\\s*\\}\\}`, 'g');
                result = result.replace(regexCondition, this.translationMap[key]);
            }
        }

        // replace all href attributes
        result = result.replace(/href=\".+?\"/gi, '');

        return result;
    }

    constructCoursyUrl () {
        const portsToSkip = [80, 443]; // do not show ports in case of http or https, but show in case of dev environment
        if (portsToSkip.includes(parseInt(this.$location.port(), 10))) {
            return `${this.$location.protocol()}://${this.$location.host()}/${this.$state.href('authorized')}`;
        }

        return `${this.$location.protocol()}://${this.$location.host()}:${this.$location.port()}/${this.$state.href('authorized')}`;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/template/preview/index.js